<template>
  <div id="options">
    <!-- Pull up their data, with an add button -->
    <!-- table of students -->
    <b-container id="options-table" fluid>
      <b-row class="mt-4">
        <b-col cols="6" class="mr-4">
          <table class="table table-striped table-hover">
            <caption>Drag and drop to rearrange</caption>
            <thead class="thead-light">
              <tr>
                <th class="col-md-5" scope="col">Option</th>
                <th class="col-md-2" scope="col"></th>
              </tr>
            </thead>
            <draggable
              v-model="options"
              @start="drag = true"
              @end="drag = false, saveOptions()"
              tag="tbody"
            >
              <tr v-for="option in options" :key="option.id">
                <td>
                  <h4>{{ option.option }}</h4>
                </td>
                <td>
                  <b-link class="delete" @click.stop="removeOption(option)">X</b-link>
                </td>
              </tr>
            </draggable>
          </table>
        </b-col>
        <b-col cols="5">
          <div class="table-wrap">
            <h4 class="subtitle">Add Option:</h4>
            <div class="input-group mb-3">
              <input
                v-model="optionToAdd"
                type="text"
                class="form-control"
                placeholder="Option to add"
                aria-label="Option to add"
                aria-describedby="basic-addon2"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary"
                  type="button"
                  @click.prevent="addOption"
                >Add</button>
              </div>
            </div>
            <br />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import OptionsService from "../services/OptionsService";
import { flash } from "../mixins/flashes";
import { scrollTo } from "../mixins/scrollTo";
import draggable from "vuedraggable";

export default {
  name: "Options",
  mixins: [flash, scrollTo],
  components: {
    draggable
  },
  props: ["optionKey"],
  data() {
    return {
      optionsFields: [
        { key: "option", label: "Option" },
        { key: "remove", label: "Remove" }
      ],
      options: [],
      optionToAdd: "",
      id: ""
    };
  },
  methods: {
    ...mapActions({
      GET_OPTIONS: "optionsList/GET_OPTIONS",
      UPDATE_OPTIONS: "optionsList/UPDATE_OPTIONS"
    }),
    optionsTable() {
      this.options = [];
      this.optionsList.forEach(element => {
        if (element.key == this.optionKey) {
          this.id = element.id;
          element.values.forEach(value => {
            this.options.push({
              id: element.values.indexOf(value),
              option: value
            });
          });
        }
      });
    },
    async saveOptions() {
      const props = {
        id: this.id,
        values: []
      };
      this.options.forEach(optioni => {
        props.values.push(optioni.option);
      });
      await OptionsService.updateOptionsList(props);
      await this.GET_OPTIONS();
    },
    async addOption() {
      const tempOption = {
        id: this.options.length,
        option: this.optionToAdd
      };
      this.options.push(tempOption);

      const props = {
        id: this.id,
        values: []
      };
      this.options.forEach(optioni => {
        props.values.push(optioni.option);
      });
      await OptionsService.updateOptionsList(props);
      await this.GET_OPTIONS();
    },
    async removeOption(option) {
      let index;
      const props = {
        id: this.id,
        values: []
      };
      this.options.forEach(optioni => {
        if (optioni == option) {
          index = this.options.indexOf(option);
        } else {
          props.values.push(optioni.option);
        }
      });
      this.options.splice(index, 1);
      await OptionsService.updateOptionsList(props);
      await this.GET_OPTIONS();
    },
    stopClick(row) {}
  },
  computed: {
    ...mapGetters({}),
    optionsList: {
      get() {
        return this.$store.state.optionsList.optionsList;
      }
    },
    adminAreas: {
      get() {
        return this.$store.state.adminAreas;
      }
    }
  },
  watch: {
    optionsList(val) {
      this.optionsTable();
    }
  },
  created() {
    this.optionsTable();
  }
};
</script>

<style scoped>
.add {
  color: green;
  font-weight: bold;
}

.small-date {
  font-style: italic;
  font-size: 10px;
  color: #5a6269;
}

table th,
table tr {
  text-align: center;
  word-break: break-all;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.delete {
  color: #9f020f;
  font-weight: bold;
}
</style>
